import { render, staticRenderFns } from "./ModalTrigger.vue?vue&type=template&id=0fd85ead&"
import script from "./ModalTrigger.vue?vue&type=script&lang=js&"
export * from "./ModalTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ef2/Projecten/vue-components/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fd85ead')) {
      api.createRecord('0fd85ead', component.options)
    } else {
      api.reload('0fd85ead', component.options)
    }
    module.hot.accept("./ModalTrigger.vue?vue&type=template&id=0fd85ead&", function () {
      api.rerender('0fd85ead', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/ModalTrigger.vue"
export default component.exports